import { NavLink } from 'react-router-dom';
import React, { useEffect } from 'react';

import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const homeUrl = process.env.REACT_APP_HOME_URL;

const Blogs = () => {

return (

<div className="blogs_wrapper">
	<div className="articals_mainsec">
		<div className="container">
			<div className="row">
				<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
					<div className="title_mainsec">
						<h2>Blogs</h2>
					</div>
				</div>
			</div>
			
			<div className="row">
				<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div className="articals_mainbox">
						<div className="articals_imgbox">
							<img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge.jpg`} />
						</div>
						
						<div className="articals_contntbox">
							<div className="artical_info">
								<span className="author_name">Admin</span>
								<span className="time_txt">3 mins ago</span>
							</div>
							
							<div className="artical_contnt">
								<h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div className="articals_mainbox">
						<div className="articals_imgbox">
							<img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge02.jpg`} />
						</div>
						
						<div className="articals_contntbox">
							<div className="artical_info">
								<span className="author_name">Admin</span>
								<span className="time_txt">April 15, 2025</span>
							</div>
							
							<div className="artical_contnt">
								<h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div className="articals_mainbox">
						<div className="articals_imgbox">
							<img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge03.jpg`} />
						</div>
						
						<div className="articals_contntbox">
							<div className="artical_info">
								<span className="author_name">Admin</span>
								<span className="time_txt">April 8, 2025</span>
							</div>
							
							<div className="artical_contnt">
								<h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div className="articals_mainbox">
						<div className="articals_imgbox">
							<img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge.jpg`} />
						</div>
						
						<div className="articals_contntbox">
							<div className="artical_info">
								<span className="author_name">Admin</span>
								<span className="time_txt">3 mins ago</span>
							</div>
							
							<div className="artical_contnt">
								<h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div className="articals_mainbox">
						<div className="articals_imgbox">
							<img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge02.jpg`} />
						</div>
						
						<div className="articals_contntbox">
							<div className="artical_info">
								<span className="author_name">Admin</span>
								<span className="time_txt">April 15, 2025</span>
							</div>
							
							<div className="artical_contnt">
								<h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div className="articals_mainbox">
						<div className="articals_imgbox">
							<img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge03.jpg`} />
						</div>
						
						<div className="articals_contntbox">
							<div className="artical_info">
								<span className="author_name">Admin</span>
								<span className="time_txt">April 8, 2025</span>
							</div>
							
							<div className="artical_contnt">
								<h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div className="articals_mainbox">
						<div className="articals_imgbox">
							<img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge.jpg`} />
						</div>
						
						<div className="articals_contntbox">
							<div className="artical_info">
								<span className="author_name">Admin</span>
								<span className="time_txt">3 mins ago</span>
							</div>
							
							<div className="artical_contnt">
								<h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div className="articals_mainbox">
						<div className="articals_imgbox">
							<img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge02.jpg`} />
						</div>
						
						<div className="articals_contntbox">
							<div className="artical_info">
								<span className="author_name">Admin</span>
								<span className="time_txt">April 15, 2025</span>
							</div>
							
							<div className="artical_contnt">
								<h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div className="articals_mainbox">
						<div className="articals_imgbox">
							<img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge03.jpg`} />
						</div>
						
						<div className="articals_contntbox">
							<div className="artical_info">
								<span className="author_name">Admin</span>
								<span className="time_txt">April 8, 2025</span>
							</div>
							
							<div className="artical_contnt">
								<h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div className="row">
				<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
					<div className="btn_mainsec">
						<a className="btn_style" href="#">Load More</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

);
};

export default Blogs;